function getShippingAndDeliveryDates() {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Define holidays for a given year
  const holidays = (year) => [
    luxon.DateTime.fromObject({ year, month: 1, day: 1 }),      // New Year's Day
    luxon.DateTime.fromObject({ year, month: 1, day: 6 }),      // Epiphany
    luxon.DateTime.fromObject({ year, month: 4, day: 18 }),     // Good Friday
    luxon.DateTime.fromObject({ year, month: 4, day: 20 }),     // Easter Sunday
    luxon.DateTime.fromObject({ year, month: 4, day: 21 }),     // Easter Monday
    luxon.DateTime.fromObject({ year, month: 5, day: 1 }),      // May Day
    luxon.DateTime.fromObject({ year, month: 5, day: 29 }),     // Ascension Day
    luxon.DateTime.fromObject({ year, month: 6, day: 6 }),      // National Day
    luxon.DateTime.fromObject({ year, month: 6, day: 8 }),      // Whit Sunday
    luxon.DateTime.fromObject({ year, month: 6, day: 20 }),      // Especial Request
    luxon.DateTime.fromObject({ year, month: 6, day: 21 }),     // Midsummer Day
    luxon.DateTime.fromObject({ year, month: 11, day: 1 }),     // All Saint's Day
    luxon.DateTime.fromObject({ year, month: 12, day: 24 }),    // Christmas Eve
    luxon.DateTime.fromObject({ year, month: 12, day: 25 }),    // Christmas Day
    luxon.DateTime.fromObject({ year, month: 12, day: 26 }),     // 2nd Day of Christmas
    luxon.DateTime.fromObject({ year, month: 12, day: 31 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 2 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 3 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 4 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 5 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 6 }),
    luxon.DateTime.fromObject({ year, month: 5, day: 14 }),
    luxon.DateTime.fromObject({ year, month: 6, day: 19 })
  ];

  const blackoutDates = (year) => [
    luxon.DateTime.fromObject({ year, month: 4, day: 2 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 3 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 4 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 5 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 6 }),
    luxon.DateTime.fromObject({ year, month: 5, day: 1 }),
    luxon.DateTime.fromObject({ year, month: 5, day: 14 }),
    luxon.DateTime.fromObject({ year, month: 6, day: 19 })   
  ];

  const isBlackoutDate = (date) => {
    const blackoutList = blackoutDates(date.year);
    return blackoutList.some(blackout => blackout.hasSame(date, 'day'));
  };

  let now = luxon.DateTime.now().setZone('Europe/Stockholm', { keepLocalTime: false });

  const currentHour = now.hour;
  const currentDay = now.weekday; // 1 = Monday, 7 = Sunday

  const pdpWidget = document.querySelector('.delivery__container');
  if(pdpWidget) {
    if (currentDay === 5) {
      document.querySelector('.delivery__container').style.display = 'none';
    } else {
      document.querySelector('.delivery__container').style.display = 'block';
    }

    if(isBlackoutDate(now)) {
      document.querySelector('.delivery__container').style.display = 'none';
    }
  }

  // Check if a date is a holiday
  const isHoliday = (date) => {
    const holidayDates = holidays(date.year);
    return holidayDates.some(holiday => holiday.hasSame(date, 'day'));
  };

  // Get the next business day
  const getNextBusinessDay = (date) => {
    do {
      date = date.plus({ days: 1 });
    } while (date.weekday > 5 || isHoliday(date)); // Skip weekends and holidays
    return date;
  };

  let shippingDate;
  let deliveryDate;

  // Determine shipping and delivery dates based on current day and hour
  if (currentDay >= 1 && currentDay <= 4) { // Monday to Thursday
    if (currentHour < 15 && !isHoliday(now)) {
      shippingDate = now;
      deliveryDate = getNextBusinessDay(now);
    } else {
      shippingDate = getNextBusinessDay(now);
      deliveryDate = getNextBusinessDay(shippingDate);
    }
  } else if (currentDay === 5) { // Friday
    if (currentHour < 15 && !isHoliday(now)) {
      shippingDate = now;
      deliveryDate = getNextBusinessDay(now.plus({ days: 1 })); // Adjust for weekend
    } else {
      shippingDate = getNextBusinessDay(now);
      deliveryDate = getNextBusinessDay(shippingDate);
    }
  } else { // Saturday or Sunday
    shippingDate = getNextBusinessDay(now);
    deliveryDate = getNextBusinessDay(shippingDate);
  }

  // Ensure holidays are skipped correctly
  if (isHoliday(shippingDate)) {
    shippingDate = getNextBusinessDay(shippingDate);
  }
  if (isHoliday(deliveryDate)) {
    deliveryDate = getNextBusinessDay(deliveryDate);
  }

  // Format shipping date for display
  const formatShippingDate = () => {
    if (now.hasSame(shippingDate, 'day')) {
      return "Today";
    } else if (shippingDate.hasSame(now.plus({ days: 1 }), 'day')) {
      return "Tomorrow";
    } else {
      return `${monthsOfYear[shippingDate.month - 1]} ${shippingDate.day}`;
    }
  };

  // Format delivery date for display
  const formatDeliveryDate = () => {
    if (deliveryDate.hasSame(now, 'day')) {
      return "Today";
    } else if (deliveryDate.hasSame(now.plus({ days: 1 }), 'day')) {
      return "Tomorrow";
    } else {
      return `${monthsOfYear[deliveryDate.month - 1]} ${deliveryDate.day}`;
    }
  };

  return {
    shippingMessage: formatShippingDate(),
    deliveryMessage: formatDeliveryDate()
  };
}

document.addEventListener('DOMContentLoaded', function () {
  const shippingElement = document.querySelector('.date__estimated');

  if (shippingElement) {
    const { shippingMessage } = getShippingAndDeliveryDates();
    shippingElement.textContent = shippingMessage;
  }
});



document.addEventListener('DOMContentLoaded', function () {
  const countdownElement = document.querySelector('.countdown__timer');

  if(countdownElement) {
    const now = luxon.DateTime.now().setZone('Europe/Stockholm', { keepLocalTime: false });
    let targetTime;

    // Check if it's Friday after 15:00 PM or Saturday
    if ((now.weekday === 5 && now.hour >= 15) || now.weekday === 6) {
      //console.log("The countdown will not be displayed because it is Friday after 3:00 PM or Saturday.");
      countdownElement.style.display = 'none'; // Hide the countdown
      return; // Stop execution
    }

    // Set the target date and time
    if (now.hour >= 15) {
      // If it is after 3:00 PM today, set the target to tomorrow at 3:00 PM
      targetTime = now.plus({ days: 1 }).set({
        hour: 15,
        minute: 0,
        second: 0
      }).setZone('Europe/Stockholm');
      
      //console.log("Target date (tomorrow at 15:00 PM): ", targetTime.toString());
    } else {
      // If it is before 3:00 PM today, set the target to today at 3:00 PM
      targetTime = luxon.DateTime.fromObject({
        year: now.year,
        month: now.month,
        day: now.day,
        hour: 15,
        minute: 0,
        second: 0
      }, { zone: 'Europe/Stockholm' }); // Specify timezone directly

      //console.log("Target date (today at 15:00 PM): ", targetTime.toString());
    }

    // Function to update the countdown
    const updateCountdown = () => {
      const now = luxon.DateTime.now().setZone('Europe/Stockholm', { keepLocalTime: false });
      //console.log("Testing date: " + now.toFormat('dd-MM-yyyy -- HH:mm'));
      //let now = luxon.DateTime.fromObject({ year: 2024, month: 12, day: 27, hour: 15, minute: 36 }, { zone: 'Europe/Stockholm' });
      const timeRemaining = targetTime.diff(now, ['hours', 'minutes', 'seconds']);
      
      // Function to format the remaining time (in HH:MM:SS)
      const formatTime = (time) => {
        const hours = String(Math.max(0, Math.floor(time.hours))).padStart(2, '0');
        const minutes = String(Math.max(0, Math.floor(time.minutes))).padStart(2, '0');
        const seconds = String(Math.max(0, Math.floor(time.seconds))).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      };

      // Update the countdown text
      countdownElement.textContent = `Order within ${formatTime(timeRemaining)} hrs to get it by:`;

      // Stop the animation if time runs out
      if (timeRemaining.hours <= 0 && timeRemaining.minutes <= 0 && timeRemaining.seconds <= 0) {
        clearInterval(interval);  // Stop the update interval
      }
    };

    // Call the update function immediately for the first calculation
    updateCountdown();

    // Animate the countdown (update it every second)
    let interval = setInterval(updateCountdown, 1000);  // Update every second
  }
});
